import { Link } from 'react-router-dom';
import { FOOTER_COLUMNS } from '@/data/content';

const SOCIALS = [
  { name: '微信', icon: 'W' },
  { name: 'B站', icon: 'B' },
  { name: '抖音', icon: 'D' },
  { name: 'GitHub', icon: 'G' },
];

export default function Footer() {
  return (
    <footer className="bg-bg-black mecha-divider">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="flex flex-col md:flex-row gap-10">
          {/* Left: Logo + Slogan + Social */}
          <div className="md:w-64 shrink-0">
            <Link to="/" className="flex items-center mb-3">
              <img src="/images/logo-full.png" alt="logo" className="h-4 w-auto object-contain" />
            </Link>
            <p className="text-xs text-text-secondary leading-relaxed">
              RoboRush — 从第一颗螺丝到无限可能。拼装 / 改装 / 编程 / 对战。
            </p>
            <div className="flex gap-2 mt-3">
              {SOCIALS.map((s) => (
                <span key={s.name} className="w-7 h-7 rounded border border-border-dark flex items-center justify-center text-[10px] text-text-disabled hover:text-arena-blue hover:border-arena-blue transition-colors cursor-pointer" title={s.name}>
                  {s.icon}
                </span>
              ))}
            </div>
            <p className="text-[11px] text-text-disabled mt-2">support@modular-robot.cn</p>
          </div>

          {/* Right: 5-column links */}
          <div className="flex-1 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-5 gap-4">
            {FOOTER_COLUMNS.map((col) => (
              <div key={col.title}>
                <h4 className="text-xs font-medium text-text-primary mb-2">{col.title}</h4>
                <ul className="space-y-1.5">
                  {col.links.map((link) => (
                    <li key={link}>
                      <Link to="/" className="text-[11px] text-text-secondary hover:text-arena-blue transition-colors">
                        {link}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-8 pt-4 border-t border-border-dark text-center text-[11px] text-text-disabled">
          <span>&copy; 2026 <a href="https://zhongkui.tech" target="_blank" rel="noopener noreferrer" className="hover:text-arena-blue transition-colors">中睽智汇</a> | RoboRush</span>
          <span className="mx-3">|</span>
          <a href="https://beian.miit.gov.cn" target="_blank" rel="noopener noreferrer" className="hover:text-text-secondary transition-colors">辽ICP备2026012818号-2</a>
        </div>
      </div>
    </footer>
  );
}
